import {
  FC,
  MouseEvent as ReactMouseEvent,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import TabItem from '../../TabItem';
import { IStudent } from '../../../models/students.model';
import { useTranslation } from 'react-i18next';
import { StudentContents } from '../../../pages/student/student';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import TableEmpty from '../../common/TableEmpty';

interface IProps {
  tabIndex: number;
  student?: IStudent;
  renderTabContent(): ReactNode;
  onClick(e: ReactMouseEvent, index: number): void;
}

const StudentTab: FC<IProps> = ({
  tabIndex,
  student,
  renderTabContent,
  onClick,
}) => {
  const { t } = useTranslation();

  const studentTabs = [
    {
      label: t('student.student.tab1'),
      value: StudentContents.Info,
    },
    {
      label: t('student.student.tab2'),
      value: StudentContents.Class,
    },
    {
      label: t('student.student.tab3'),
      value: StudentContents.Counsel,
    },
    {
      label: t('student.student.tab4'),
      value: StudentContents.Payment,
    },
    {
      label: t('student.student.tab5'),
      value: StudentContents.Refund,
    },
    {
      label: t('student.student.tab6'),
      value: StudentContents.Coupon,
    },
    {
      label: t('student.student.tab7'),
      value: StudentContents.Score,
    },
    {
      label: t('student.student.tab12'),
      value: StudentContents.Point,
    },
    {
      label: t('student.student.tab8'),
      value: StudentContents.Attendance,
    },
    {
      label: t('student.student.tab9'),
      value: StudentContents.Test,
    },
    {
      label: t('student.student.tab13'),
      value: StudentContents.Book,
    },
    {
      label: 'Articles',
      value: StudentContents.Article,
    },
    {
      label: t('student.student.65'),
      value: StudentContents.SchoolRecord,
    },
    {
      label: t('student.student.tab10'),
      value: StudentContents.Memo,
    },
    {
      label: t('student.student.tab11'),
      value: StudentContents.Message,
    },
    {
      label: t('class.class.title16'),
      value: StudentContents.Award,
    },
  ];
  return (
    <div>
      <div className="comm-tab__line">
        <ul>
          {studentTabs.map((item) => (
            <TabItem
              key={`student-${item.value}`}
              text={item.label}
              index={item.value}
              isActive={tabIndex === item.value}
              onClick={onClick}
            />
          ))}
        </ul>
      </div>
      <div>
        <div className="tab-content" id="custom-tabs-tabContent">
          {student ? (
            <div>{renderTabContent()}</div>
          ) : (
            <TableEmpty text={t('student.student.text1')} />
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentTab;
